export default __webpack_public_path__ + "static/media/InternalSalesOffIcon.67871312.svg";